import {Column, ColumnModel} from "@syncfusion/ej2-react-grids";

interface GridColumnModel extends ColumnModel {
  /**
   * Specifies if the column is computed or not. If true this column is not fetched from the server.
   */
  isComputed?: boolean
}

export default class GridColumn extends Column {
  public isComputed?: boolean;

  constructor(opts: GridColumnModel) {
    const {isComputed, ...superOpts} = opts;
    super({...superOpts});
    this.isComputed = isComputed;
  }
}

export const GRID_COLUMN_DEFAULT_WIDTH = 200;
